import React from 'react';

interface KOLColorPaletteCardProps {
  lightColor: string;
  darkColor: string;
  onClick: () => void;
  isSelected: boolean;
}

export const KOLColorPaletteCard = ({ lightColor, darkColor, onClick, isSelected }: KOLColorPaletteCardProps) => {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer transition-all duration-200 w-40 ${isSelected ? 'ring-2 ring-colorsBrandRed01Primary rounded-lg' : 'transform  scale-90'}`}
      role="radio"
      aria-checked={isSelected}
      tabIndex={0}
      onKeyDown={(e) => ['Enter', ' '].includes(e.key) && onClick()}
    >
      <div className="rounded-lg overflow-hidden flex flex-col shadow-md">
        <div className="flex h-12">
          <div style={{ backgroundColor: lightColor }} className="w-1/2 h-full" />
          <div style={{ backgroundColor: darkColor }} className="w-1/2 h-full" />
        </div>
        <div className="h-8 bg flex items-center justify-around px-2">
          <p className="text-12" style={{ color: lightColor }}>
            {lightColor.substring(1)}
          </p>
          <p className="text-12" style={{ color: darkColor }}>
            {darkColor.substring(1)}
          </p>
        </div>
      </div>
    </div>
  );
};
